import React, {Component} from 'react'
import {connect} from 'react-redux'
import FJPreviewLink from "../view/FJPreviewLink";
import FJPreviewRetry from "../view/FJPreviewRetry";
import FJTimelineStore from "fj-timeline";
import FJViewConstant from "../../../constant/FJViewConstant";
import {FJMediaAction} from "../../../redux/action/FJRoot.action";

class FJPreviewMediaStatusContainer extends Component {

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return this._getStatus(this.props) !== this._getStatus(nextProps);
  }

  _getStatus = (props) => {
    let {bricks, currentTime} = props;
    let {MEDIA_STATUS_SUCCESS} = FJViewConstant;
    let x = FJTimelineStore.timeToPixel(currentTime);
    let curMainBrick = bricks.mainLayer.find(item => {
      return x >= item.x && x <= item.x + item.width;
    });
    return curMainBrick ? curMainBrick.sourceStatus : MEDIA_STATUS_SUCCESS;
  };

  render() {
    let {bricks, currentTime, retryMedia} = this.props;
    let {MEDIA_STATUS_RETRY, MEDIA_STATUS_LINK} = FJViewConstant;
    let x = FJTimelineStore.timeToPixel(currentTime);
    let curMainBrick = bricks.mainLayer.find(item => {
      return x >= item.x && x <= item.x + item.width;
    });
    let status = this._getStatus(this.props);
    switch (status) {
	    case MEDIA_STATUS_LINK:
	    	return <FJPreviewLink />;
	    case MEDIA_STATUS_RETRY:
	    	return <FJPreviewRetry sourceId={curMainBrick.sourceId} retryClick={retryMedia} />;
	    default:
	    	return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    bricks: state.timeline.bricks,
    currentTime: state.timeline.currentTime,
  }
};

const mapDispatchToProps = (dispatch) => {
	return {
		retryMedia: function (id) {
			dispatch(FJMediaAction.retryMediaAction(id));
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(FJPreviewMediaStatusContainer);
